var index = function index(string) {
  if (string && string.split) {
    return string.split(/_|-| /).map(function (part) {
      return part[0].toUpperCase() + part.substr(1).toLowerCase();
    }).join('');
  }
  return string;
};
export default index;